module.exports = __webpack_public_path__ + "img/income-and-expense-log_B09K24NLXR.2f3ceb3f.jpg";